import { render, staticRenderFns } from "./SendDocumentTemplateEdit.vue?vue&type=template&id=3b996e88&scoped=true&lang=pug"
import script from "./SendDocumentTemplateEdit.vue?vue&type=script&lang=ts"
export * from "./SendDocumentTemplateEdit.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentTemplateEdit.vue?vue&type=style&index=0&id=3b996e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b996e88",
  null
  
)

export default component.exports